import makeRoutes from "@/routes/Base/Route";

export default [
    ...makeRoutes('container_support').map(route => {
        return {
            ...route,
            meta: {permission: route.name}
        }
    })
]